module.exports = "/_next/static/images/vessel-image-64c31c1c1a1284affacff5e36c6eff87.svg";